import { render, staticRenderFns } from "./ComplieRightCanvas.vue?vue&type=template&id=47bf5dee&scoped=true"
import script from "./ComplieRightCanvas.vue?vue&type=script&lang=js"
export * from "./ComplieRightCanvas.vue?vue&type=script&lang=js"
import style0 from "./ComplieRightCanvas.vue?vue&type=style&index=0&id=47bf5dee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bf5dee",
  null
  
)

export default component.exports